<template>
  <div class="ml-6 mr-0">
    <v-btn width="110" rounded color="#F4F2F7" class="sigfloButtonSmall600 textEmphasis elevation-0 text-capitalize">
      <v-icon color="rgba(17,11,25,0.2)" class="mr-2" v-show="quantity <= product.minQuantity">mdi-minus</v-icon>
      <v-icon @click="quantity = quantity - 1" class="mr-2" v-show="quantity > product.minQuantity">mdi-minus</v-icon
      >{{ quantity
      }}<v-icon class="ml-2" v-show="quantity < product.maxQuantity" @click="quantity = quantity + 1">mdi-plus</v-icon>
      <v-icon color="rgba(17,11,25,0.2)" class="ml-2" v-show="quantity >= product.maxQuantity">mdi-plus</v-icon>
    </v-btn>
  </div>
</template>

<script>
  export default {
    props: {
      product: {
        type: Object,
        required: true
      }
    },
    data() {
      return {};
    },
    computed: {
      quantity: {
        set(value) {
          this.$store.commit('configurator/updateProductQuantity', {
            productId: this.product.id,
            quantity: Number(value)
          });
        },
        get() {
          return this.product.quantity;
        }
      }
    },
    methods: {}
  };
</script>
